<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('AddMonthlyWorkingHours') | ToUppercase">
                <small>{{$t('Date') |ToUppercase}}</small><br>
                <datepicker v-model="date"></datepicker>

                <vs-upload automatic :action="'/api/excel/monthlyWorkingHours/' + monthlyWorkingHoursId" :text="$t('UploadExcel')" limit="1" fileName="file" @on-success="successUpload" @on-error="errorUpload"/>

                <div class="mt-6">
                    <vs-button class="mr-2" @click="addMonthlyWorkingHours()">{{ $t("Add") | ToUppercase }}</vs-button>
                    <vs-button @click="$router.go(-1)">{{ $t("Back") | ToUppercase }}</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                date: null,
                monthlyWorkingHoursId : -1,
            };
        },
        methods: {
            addMonthlyWorkingHours() {
                this.$vs.loading();
                const thisIns = this;
                var dateForRequest = new Date(this.date.getFullYear(), this.date.getMonth(), 2, 0, 0, 0)

                if(this.monthlyWorkingHoursId != -1) {
                    //File is already saved
                    //Call edit report instead of add
                    this.$http.put("/monthly-working-hours/", {
                        id: thisIns.monthlyWorkingHoursId,
                        date: dateForRequest,
                    }).then(function () {
                        thisIns.$vs.notify({
                            text: "Mesečne opravljene delovne ure shranjene",
                            color: "success",
                        });
                        thisIns.$router.push('/monthly-working-hours/all');
                    }).catch(function () {
                        thisIns.$vs.notify({
                            text: "Napaka pri shranjevanju",
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                        });
                    }).finally(function () {
                        thisIns.$vs.loading.close();
                    });
                }
                else {
                    //File is not added yet
                    //Call add normaly
                    this.$http.post("/monthly-working-hours/add", {
                        id: thisIns.monthlyWorkingHoursId,
                        date: dateForRequest,
                    }).then(function () {
                        thisIns.$vs.notify({
                            text: "Mesečne opravljene delovne ure shranjene",
                            color: "success",
                        });
                        thisIns.$router.push('/monthly-working-hours/all');
                    }).catch(function () {
                        thisIns.$vs.notify({
                            text: "Napaka pri shranjevanju",
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                        });
                    }).finally(function () {
                        thisIns.$vs.loading.close();
                    });
                }
            },
            successUpload(response) {
                this.monthlyWorkingHoursId = parseInt(response.target.responseText);
                this.$vs.notify({
                    color:'success',
                    text:'Excel uspečno shranjen'
                })
            },
            errorUpload(response) {
                this.$vs.notify({
                    color:'danger',
                    text: response.target.responseText
                })
            }
        },
        created() {
            
        },
    };
</script>